import React from 'react';

interface ResponsiveTextProps {
  min: number; // px
  max: number; // px
  children: React.ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

const Text: React.FC<ResponsiveTextProps> = ({
  min,
  max,
  children,
  className = '',
  as: Component = 'p',
}) => {
  // Use a realistic mobile to desktop range
  const minScreen = 450;
  const maxScreen = 1800;

  // Calculate the slope for vw
  const slope = ((max - min) / (maxScreen - minScreen)) * 100;

  // Offset to adjust for starting min
  const yIntercept = min - slope * (minScreen / 100);

  const fontSize = `clamp(${min}px, ${yIntercept}px + ${slope}vw, ${max}px)`;

  return (
    <Component className={className} style={{ fontSize, lineHeight: 'normal' }}>
      {children}
    </Component>
  );
};

export default Text;
